import axios from 'axios';

const CHAT_PATH = '/workflow/v1/admin/property-listing-agent';

const loadAbort = () => new AbortController();

export const initChatEndpoint = (
  propertyCode: string,
  marketplaceType: string,
  token: string,
) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'post',
        url: `${urlService}${CHAT_PATH}/init`,
        data: { property_code: propertyCode, marketplace_type: marketplaceType },
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        signal: controller.signal,
      }),
    controller,
  };
};

export const sendChatMessageEndpoint = (
  message: string,
  propertyCode: string,
  marketplaceType: string,
  token: string,
) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'post',
        url: `${urlService}${CHAT_PATH}/chat`,
        data: { message, property_code: propertyCode, marketplace_type: marketplaceType },
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        signal: controller.signal,
      }),
    controller,
  };
};
